export default __webpack_public_path__ + "static/media/imageDefault.9b567451.png";